export const CREATE_POLL = "SUPERCHAT_CREAR_ENCUESTA";
export const POLL_OPTIONS = "SUPERCHAT_POLL_OPTIONS";
export const MULTIPLE_ANSWER = "SUPERCHAT_MULTIPLE_ANSWER";
export const INCREASE_VOTE = "SUPERCHAT_INCREASE_VOTE";
export const INCREASE_VOTE_MULTI_ANSWER =
  "SUPERCHAT_INCREASE_VOTE_MULTI_ANSWER";
export const SEND_MESSAGE = "SUPERCHAT_SAVE_MESSAGE";
export const FINISH_SURVEY = "SUPERCHAT_FINISH_SURVEY";
